import request from "@/utils/request"

//发票信息
export function invoiceInfo(data) {
  return request({
    url: "api/v2/qywx/receipt/invoice",
    method: "post",
    data,
  })
}
//发票确认
export function invoiceConfirm(data) {
  return request({
    url: "api/v2/qywx/receipt/invoice/confirm",
    method: "post",
    data,
  })
}

//银行信息
export function bankInfo(data) {
  return request({
    url: "api/v2/qywx/receipt/bank",
    method: "post",
    data,
  })
}
//银行确认
export function bankConfirm(data) {
  return request({
    url: "api/v2/qywx/receipt/bank/confirm",
    method: "post",
    data,
  })
}
//工资
export function salaryInfo(data) {
  return request({
    url: "api/v2/qywx/receipt/salary",
    method: "post",
    data,
  })
}

//工资确认
export function salaryConfirm(data) {
  return request({
    url: "api/v2/qywx/receipt/salary/confirm",
    method: "post",
    data,
  })
}

//工资告知客户
export function salaryExcel(data) {
  return request({
    url: "api/v2/qywx/receipt/salary/excel",
    method: "post",
    data,
  })
}
